import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Response } from '@shared/interfaces/response/response';
import { User, ICreateUserRequest, ICreateUserApiResponse, IUpdateUserRequest, IUpdateUserApiResponse, IUserNew, IUserListResponse } from '@pages/authentication/interfaces/user';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({ providedIn: "root" })
export class UserService {
    private _url = environment.apiBaseUrl + "api/user/";
    public userCurrent: string = "Invitado";

    constructor(private _http: HttpClient) {
    }

    ForgotPassword(data: any) {
        return this._http.post<any>(environment.apiBaseUrl + "api/Token/" + "ForgotPasswordSendEmail", data, httpOption);
    }
    UpdatePassword(data: any) {
        return this._http.post<any>(environment.apiBaseUrl + "api/Token/" + "UpdatePassword", data, httpOption);
    }

    create(model: User): Observable<Response> {
        return this._http.post<Response>(this._url, model, httpOption);
    }

    read(): Observable<Response> {
        return this._http.get<Response>(this._url);
    }

    update(model: User): Observable<Response> {
        return this._http.put<Response>(this._url, model, httpOption);
    }

    delete(model: User): Observable<Response> {
        return this._http.request<Response>("delete", this._url, {
            body: model,
        });
    }

    createUserInDS(model) {
        return this._http.post(this._url + "SpCreate", model);
    }

    getUserInDS(model) {
        return this._http.post(this._url + "GetUser?sUSUARIO=" + model, null);
    }

    // Nuevo método para el endpoint GetNwUsrs
    createUserNew(model: ICreateUserRequest): Observable<ICreateUserApiResponse> {
        return this._http.post<ICreateUserApiResponse>(
            environment.apiNewBackBaseUrl + "UsuarsCS/GetNwUsrs", 
            model
        );
    }

    // Nuevo método para el endpoint GetUpdUsrs
    updateUserNew(model: IUpdateUserRequest): Observable<IUpdateUserApiResponse> {
        return this._http.post<IUpdateUserApiResponse>(
            environment.apiNewBackBaseUrl + "UsuarsCS/GetUpdUsrs", 
            model
        );
    }

    // Nuevo método para el endpoint GetNwUsrsLst
    getUsersListNew(): Observable<IUserListResponse> {
        return this._http.post<IUserListResponse>(
            environment.apiNewBackBaseUrl + "UsuarsCS/GetNwUsrsLst",
            { "tope": "9999" }
        );
    }

    // Método para obtener niveles de usuario
    getNivelesUsuario(tope: string, claveUsuario: string): Observable<any> {
        return this._http.post<any>(
            environment.apiNewBackBaseUrl + "UsuarsCS/GetNiveLst",
            {
                "tope": tope,
                "clave_usuario": claveUsuario
            }
        );
    }

    // Método para obtener tipos de crédito
    getTiposCredito(): Observable<any> {
        return this._http.post<any>(
            environment.apiNewBackBaseUrl + "Gastos/GetGastos",
            {
                "limit": "9999"
            }
        );
    }

    // Método para guardar/crear nivel de usuario
    guardarNivelUsuario(payload: any): Observable<any> {
        return this._http.post<any>(
            environment.apiNewBackBaseUrl + "UsuarsCS/GetNiveErr",
            payload
        );
    }
}
